<template>
  <BLayoutList
    :title="pageTitle"
    :create-route="createRoute"
    :skeleton="isLoadingAsyncData"
  >
    <template #filter>
      <ComponentFilter
        :data="filters"
        :skeleton="isLoadingAsyncData"
        @change="onChangeFilter"
      />
    </template>

    <BTableCommon
      v-model="selected"
      type="vpr-publications"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      @change:pagination="onChangePagination"
      @change:sort="onChangeSort"
      @action:delete="onDeleteWithRefresh"
      @action:view="onActionView"
    />
  </BLayoutList>
</template>

<script>
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { VPRPublicationModel as Model } from './Model'
import { VPRPublicationsStoreModule as StoreModule } from './store'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import ComponentFilter from './components/PublicationsFilter.vue'
import { VPR_PUBLICATIONS_PAGES_ROUTES as ROUTES } from './utils'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)


/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'VPRPublicationsList',
  components: {
    BLayoutList,
    BTableCommon,
    ComponentFilter,
  },
  mixins: [
    listMixin,
  ],
  computed: {
    createRoute() {
      const editable = this.$access(Permissions.create)
      return editable ? { name: ROUTES.CREATE } : void 0
    },
  },
  methods: {
    onActionView(data) {
      this.$router.push({
        name: ROUTES.VIEW,
        params: {
          id: data.vpr_publication_id,
        },
      })
    },
  },
}
</script>
